export enum StoreActionType {
  UPDATE = 'value/update',
  CLEAR = 'value/clear',
  REPLACE = 'value/replace',
}

interface IUpdateAction {
  type: StoreActionType.UPDATE;
  payload: Record<string, unknown>;
}

interface IReplaceAction {
  type: StoreActionType.REPLACE;
  payload: Record<string, unknown>;
}

interface IClearAction {
  type: StoreActionType.CLEAR;
}

export type Actions = IUpdateAction | IClearAction | IReplaceAction;

export const updateStore = (value: Record<string, unknown>): IUpdateAction => ({
  type: StoreActionType.UPDATE,
  payload: value,
});

export const clearStore = (): IClearAction => ({
  type: StoreActionType.CLEAR,
});

export const replaceStore = (value: Record<string, unknown>): IReplaceAction => ({
  type: StoreActionType.REPLACE,
  payload: value,
});
